var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isiframe)?_c('div'):_c('div',[_c('v-app-bar',{attrs:{"flat":"","color":"transparent"}},[_c('v-toolbar-title',[_vm._v("2021 國際數學日 3.14")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }